import React from 'react';
import TransactionProgress from 'spa/containers/TransactionProgress';
import { withRouter } from 'react-router-dom';

const transactionProgressPage = (props) => (
  <TransactionProgress transToken={props.match.params.trans_token} />
);

export default withRouter(transactionProgressPage);
